import PropTypes from 'prop-types';

export const gridPropTypes = {
  data: PropTypes.array,
  options: PropTypes.object,
  initRow: PropTypes.object,
  height: PropTypes.string,
  unLoaded: PropTypes.bool,
  readOnly: PropTypes.bool,
  showFocusedBackground: PropTypes.bool,
  hideHeader: PropTypes.bool,
  hideFooter: PropTypes.bool,
  title: PropTypes.string, // export excel file name
  replaceDataByExcel: PropTypes.bool,
  totalUnit: PropTypes.string,
  saveButtonLabel: PropTypes.string,
  saveButtonWidth: PropTypes.string,
};

export const uploadPopupPropTypes = {
  uploadPopupProps: PropTypes.shape({
    options: PropTypes.object,
    initRow: PropTypes.object,
    addRowLabel: PropTypes.string,
    height: PropTypes.string,
    title: PropTypes.string, // export excel file name and headerText default value
    headerText: PropTypes.string, // headerText default custom value
    showFocusedBackground: PropTypes.bool,
  }),
  showUploadPopup: PropTypes.bool,
  onPopupSave: PropTypes.func,
};

export const leftHeaderButtonPropTypes = {
  showDelete: PropTypes.bool,
  showCopy: PropTypes.bool,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  headerButtonEnabled: PropTypes.bool,
};

export const rightHeaderButtonPropTypes = {
  showAddRow: PropTypes.bool,
  addRowLabel: PropTypes.string,
  showRegister: PropTypes.bool,
  customExcelForm: PropTypes.array,
  onAddRow: PropTypes.func,
  onRegister: PropTypes.func,
  addRowValidator: PropTypes.func,
  onExcelTemplateDownload: PropTypes.func,
  onExcelUpload: PropTypes.func,
  onExcelDownload: PropTypes.func,
  excelTooltip: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  excel: PropTypes.oneOf([
    'excelWork',
    'download',
    'excelSimpleWork',
    'excelWorkSmall',
    'downloadSmall',
    'excelSimpleWorkSmall',
    'excelDisabledDownload',
    'custom',
    'size',
  ]),
};

export const pagingPropTypes = {
  unPaged: PropTypes.bool,
  hidePageSize: PropTypes.bool,
  total: PropTypes.number,
  numberOfPageGroup: PropTypes.number,
  // ECMJ - 박준석
  gridSizes: PropTypes.arrayOf(
    PropTypes.shape({ label: PropTypes.string, key: PropTypes.number })
  ),
  defaultGridSizeKey: PropTypes.number,
};

export const handleGridFunctionPropTypes = {
  onSearch: PropTypes.func,
  onDeleteItems: PropTypes.func,
  onCopyItems: PropTypes.func,
  onDataChange: PropTypes.func,
  onSave: PropTypes.func,
};

export const IBSheetEventPropTypes = {
  onRenderFirstFinish: PropTypes.func,
  onBeforeDataLoad: PropTypes.func,
  onDataLoad: PropTypes.func,
  onSearchFinish: PropTypes.func,
  onAfterChange: PropTypes.func,
  onCheckboxAfterChange: PropTypes.func,
  onClick: PropTypes.func,
  onBlur: PropTypes.func,
  onFocus: PropTypes.func,
  onBeforeChange: PropTypes.func,
  onButtonClick: PropTypes.func,
  onIconClick: PropTypes.func,
  onRowAdd: PropTypes.func,
  onEndEdit: PropTypes.func,
  onResultMask: PropTypes.func,
  onShowEnumMenu: PropTypes.func,
  onAfterRowDelete: PropTypes.func,
};
